export const SAMPLE_PASSWORD = 'P@ss123';